export const typographyConfig = {
  display: {
    family: "Inter",
    size: "2.5rem",
    weight: 700,
    lineHeight: "3rem",
    letterSpacing: "-0.02em",
  },
  headline: {
    family: "Inter",
    size: "2rem",
    weight: 600,
    lineHeight: "2.5rem",
    letterSpacing: "-0.01em",
  },
  body: {
    family: "Grotesk",
    size: "1rem",
    weight: 400,
    lineHeight: "1.5rem",
    letterSpacing: "0em",
  },
  caption: {
    family: "Grotesk",
    size: "0.875rem",
    weight: 400,
    lineHeight: "1.25rem",
    letterSpacing: "0.01em",
  },
};